const KEY = 'rf:lastModule';

/** Per-browser convenience only; safe if storage is unavailable. */
export function getLastModule(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setLastModule(m: string) {
  try {
    localStorage.setItem(KEY, m);
  } catch {
    /* ignore */
  }
}
